export default __webpack_public_path__ + "static/media/tt.9d3a077c.png";